<template>
	<app-page>
		<app-heading title="Dashboard" no-breadcrumb />
		<app-row v-if="canStudeo">
			<app-cell cols="12" md="4" class="text-center">
				<app-section>
					<div class="title">New Bookings</div>
					<div
						class="success--text"
						style="font-size: 36px; line-height: 40px;"
					>{{ todayBooking.new }}</div>
				</app-section>
			</app-cell>
			<app-cell cols="12" md="4" class="text-center">
				<app-section>
					<div class="title">Cancelled Bookings</div>
					<div
						class="error--text"
						style="font-size: 36px; line-height: 40px;"
					>{{ todayBooking.cancelled }}</div>
				</app-section>
			</app-cell>
			<app-cell cols="12" md="4" class="text-center">
				<app-section>
					<div class="title">Quotes</div>
					<div
						class="grey--text"
						style="font-size: 36px; line-height: 40px;"
					>{{ todayBooking.quote }}</div>
				</app-section>
			</app-cell>
		</app-row>
		<app-section v-if="canStudeo" class="mb-4 mt-4">
			<template v-slot:title><h3>Daily Bookings</h3></template>
			<chart-line
				:colors="['grey', 'green', 'blue', 'orange', 'red']"
				:labels="bookings.labels"
				:value="bookings.value"
				:headings="bookings.headings"
				fill
				fill-opacity="80"
			/>
		</app-section>
		<app-section v-if="canIssue" class="mb-4 mt-4">
			<template v-slot:title><h3>Daily Issues</h3></template>
			<chart-line
				:colors="['red','orange','green']"
				:labels="issues.labels"
				:value="issues.value"
				:headings="issues.headings"
				fill
				fill-opacity="80"
			/>
		</app-section>
		<app-section v-if="canEvent" class="mb-4 mt-4">
			<template v-slot:title>
				<app-row no-padding>
					<app-cell>
						<h3>{{dailyEvents ? 'Daily' : 'Hourly' }} Events</h3>
					</app-cell>
					<app-cell>
						<input-button-group v-model="dailyEvents">
							<app-button no-margin small>Hourly</app-button>
							<app-button no-margin small>Daily</app-button>
						</input-button-group>
					</app-cell>
				</app-row>
			</template>
			<chart-line
				:colors="['green','red']"
				:labels="events.labels"
				:value="events.value"
				:headings="events.headings"
				fill
				fill-opacity="80"
			/>
		</app-section>
	</app-page>
</template>

<script>
function MetricType(headings = []) {
	this.init = false
	this.value = []
	this.labels = []
	this.events = []
	this.headings = headings
}

export default {
	data() {
		return {
			todayBooking: {
				new: 0,
				cancelled: 0,
				quote: 0,
			},
			bookings: new MetricType(['Quote', 'New', 'Updated', 'Cancelled', 'Error']),
			issues: new MetricType(['New', 'Ack', 'Resolved']),
			dailyEvents: 0,
			events: new MetricType(['Processed', 'Failed']),
		}
	},
	computed: {
		canIssue() {
			return this.$ravello.can('system.get')
		},
		canEvent() {
			return this.$ravello.can('system.get')
		},
		canStudeo() {
			return this.$ravello.can('studeo.get')
		},
	},
	watch: {
		canIssue: {
			immediate: true,
			handler() {
				if (this.canIssue && !this.issues.init) {
					this.fetchIssues()
				}
			},
		},
		canEvent: {
			immediate: true,
			handler() {
				if (this.canEvent && !this.events.init) {
					this.fetchEvents()
				}
			},
		},
		dailyEvents: {
			handler() {
				this.fetchEvents()
			},
		},
		canStudeo: {
			immediate: true,
			handler() {
				if (this.canStudeo && !this.bookings.init) {
					this.fetchBookings()
				}
			},
		},
	},
	methods: {
		async fetchEvents() {
			const events = await this.$ravello.request().v(2)
				.to('metrics')
				.to(this.dailyEvents ? 'daily' : 'hourly')
				.to('events')
				.get()

			const { labels, value } = events.reduce((acc, event) => {
				acc.labels.push(this.dailyEvents ? event.date : `${event.date.split(' ')[1]}:00:00`)
				acc.value[0].push(event.processed || 0)
				acc.value[1].push(event.failed || 0)
				return acc
			}, { labels: [], value: [[], []] })

			this.events.labels = labels
			this.events.value = value
			this.events.init = true
		},

		async fetchIssues() {
			const issues = await this.$ravello.request().v(2)
				.to('metrics')
				.to('daily')
				.to('issues')
				.get()

			const { labels, value } = issues.reduce((acc, issue) => {
				acc.labels.push(issue.date)
				acc.value[0].push(issue.new || 0)
				acc.value[1].push(issue.ack || 0)
				acc.value[2].push(issue.resolved || 0)
				return acc
			}, { labels: [], value: [[], [], []] })

			this.issues.labels = labels
			this.issues.value = value
			this.issues.init = true
		},

		async fetchBookings() {
			const bookings = await this.$ravello.request().v(2)
				.to('metrics')
				.to('daily')
				.to('bookings')
				.get()

			const { labels, value } = bookings.reduce((acc, booking) => {
				acc.labels.push(booking.date)
				acc.value[0].push(booking.quote || 0)
				acc.value[1].push(booking.new || 0)
				acc.value[2].push(booking.updated || 0)
				acc.value[3].push(booking.cancelled || 0)
				acc.value[4].push(booking.error || 0)

				return acc
			}, { labels: [], value: [[], [], [], [], []] })

			this.todayBooking = { ...bookings[bookings.length - 1] }
			this.bookings.labels = labels
			this.bookings.value = value
			this.bookings.init = true
		},
	},
}
</script>
